import React from "react";
import { Link } from "react-router";
import { getEnv } from "../../../config";

function Card() {
  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-12 col-md-4 mb-4">
          <div className="card unbordered">
            <i className="bg-dark bx bx-world text-white card-icon"></i>
            <div className="card-body">
              <h3 className="card-title">
                <a
                  href={
                    getEnv("REACT_APP_PORTAL_URL")
                      ? getEnv("REACT_APP_PORTAL_URL")
                      : "https://visualizador-front-dev.gcba.gob.ar/"
                  }
                  target="_blank"
                  rel="noopener noreferrer"
                  className="card-title-link text-primary"
                >
                  Visor de Mapas
                </a>
              </h3>
              <p className="card-text">
                Explorá las capas del mapa interactivo de forma integrada
              </p>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-4 mb-4">
          <div className="card unbordered">
            <i className="bg-dark bx bx-layer text-white card-icon"></i>
            <div className="card-body">
              <h3 className="card-title">
                <Link
                  to="Recursos/Geoservicios"
                  className="card-title-link text-primary"
                >
                  Geoservicios
                </Link>
              </h3>
              <p className="card-text">
                Accedé al listado de Geoservicios WMS y WFS con datos
                actualizados de la ciudad
              </p>
            </div>
          </div>
        </div>
        <div className="col-12 col-md-4 mb-4">
          <div className="card unbordered">
            <i className="bg-dark bx bx-list-ul text-white card-icon"></i>
            <div className="card-body">
              <h3 className="card-title">
                <a
                  href={getEnv("REACT_APP_GEONETWORK_URL")}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="card-title-link text-primary"
                >
                  Catálogo de metadatos
                </a>
              </h3>
              <p className="card-text">
                Accedé al servicio de búsqueda de metadatos de la información
                geoespacial
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Card;
